import React, { useState } from 'react';
import styled from 'styled-components';
import { T } from '../Translation/index';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: 24px;
`;

const Modal = styled.div`
  background: #fff;
  border-radius: 16px;
  max-width: 560px;
  width: 100%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  @media (max-width: 679px) {
    border-radius: 12px;
    max-height: 90vh;
    margin: 0 8px;
  }
`;

const Header = styled.div`
  padding: 20px 24px 0;
`;

const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #191c1d;
  margin: 0;
`;

const Body = styled.div`
  padding: 16px 24px;
  overflow-y: auto;
  flex: 1;
`;

const Message = styled.p`
  font-size: 13px;
  line-height: 1.7;
  color: #495057;
  margin: 0 0 12px 0;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Footer = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #e1e3e4;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #495057;
  cursor: pointer;
`;

const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  accent-color: #1976d2;
  cursor: pointer;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const BackBtn = styled.button`
  padding: 8px 20px;
  border: 1px solid #ced4da;
  border-radius: 8px;
  background: #fff;
  color: #495057;
  font-size: 14px;
  cursor: pointer;
  &:hover { background: #f1f3f5; }
`;

const OkBtn = styled.button<{ disabled: boolean }>`
  padding: 8px 24px;
  border: none;
  border-radius: 8px;
  background: ${({ disabled }) => (disabled ? '#bdbdbd' : '#1976d2')};
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  &:hover { background: ${({ disabled }) => (disabled ? '#bdbdbd' : '#1565c0')}; }
`;

interface DisclaimerModalProps {
  onAccept: () => void;
  onBack: () => void;
}

const DisclaimerModal: React.FC<DisclaimerModalProps> = ({ onAccept, onBack }) => {
  const [agreed, setAgreed] = useState(false);

  return (
    <Overlay>
      <Modal>
        <Header>
          <Title><T id="process_title" /></Title>
        </Header>
        <Body>
          <Message><T id="process_msg1" /></Message>
          <Message><T id="process_msg2" /></Message>
          <Message><T id="process_msg3" /></Message>
        </Body>
        <Footer>
          <CheckboxRow>
            <Checkbox
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
            />
            <T id="process_agree" />
          </CheckboxRow>
          <ButtonRow>
            <BackBtn onClick={onBack}><T id="back" /></BackBtn>
            <OkBtn disabled={!agreed} onClick={onAccept}><T id="ok" /></OkBtn>
          </ButtonRow>
        </Footer>
      </Modal>
    </Overlay>
  );
};

export default DisclaimerModal;
